import { render, staticRenderFns } from "./MarcaInput.vue?vue&type=template&id=c5af794e&"
import script from "./MarcaInput.vue?vue&type=script&lang=js&"
export * from "./MarcaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports